import MuiButton from './MuiButton';
import MuiIconButton from './MuiIconButton';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiSelect from './MuiSelect';
import MuiTableCell from './MuiTableCell';
import MuiTableHead from './MuiTableHead';
import MuiTextField from './MuiTextField';
import MuiTypography from './MuiTypography';

export default {
    MuiButton,
    MuiIconButton,
    MuiOutlinedInput,
    MuiPaper,
    MuiTableCell,
    MuiTableHead,
    MuiTextField,
    MuiTypography,
    MuiSelect,
};
